import { useRef } from 'react';
import styled from '@emotion/styled';
import Iconify from '@emfood/shared/src/components/iconify';
import { closeSnackbar, SnackbarProvider as NotistackProvider } from 'notistack';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';

import { useSettingsContext } from '../settings';
import { StyledIcon, StyledNotistack } from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export const StyledNotistackWrapper = styled('div')(({ theme }) => ({
  '.notistack-SnackbarContainer': {
    top: '60px',
  },
}));

export default function SnackbarProvider({ children }: Props) {
  const settings = useSettingsContext();

  const isRTL = settings.themeDirection === 'rtl';

  const notistackRef = useRef<any>(null);

  return (
    <StyledNotistackWrapper>
      <NotistackProvider
        ref={notistackRef}
        maxSnack={5}
        preventDuplicate
        TransitionComponent={isRTL ? Collapse : undefined}
        variant="success" // Set default variant
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        iconVariant={{
          info: (
            <StyledIcon color="info">
              <Iconify icon="eva:info-fill" width={24} />
            </StyledIcon>
          ),
          success: (
            <StyledIcon color="success">
              <Iconify icon="eva:checkmark-circle-2-fill" width={24} />
            </StyledIcon>
          ),
          warning: (
            <StyledIcon color="warning">
              <Iconify icon="eva:alert-triangle-fill" width={24} />
            </StyledIcon>
          ),
          error: (
            <StyledIcon color="error">
              <Iconify icon="solar:danger-bold" width={24} />
            </StyledIcon>
          ),
        }}
        Components={{
          default: StyledNotistack,
          info: StyledNotistack,
          success: StyledNotistack,
          warning: StyledNotistack,
          error: StyledNotistack,
        }}
        action={(snackbarId) => (
          <IconButton
            size="small"
            onClick={() => closeSnackbar(snackbarId)}
            sx={{ p: 0.5, minHeight: '44px', minWidth: '44px' }}
          >
            <Iconify width={16} icon="mingcute:close-line" />
          </IconButton>
        )}
      >
        {children}
      </NotistackProvider>
    </StyledNotistackWrapper>
  );
}
